function normalizedCountryId(item) {
  return String(item?.zcCountryId ?? "");
}

function normalizedPostcode(item) {
  return String(item?.zcZip ?? "").trim();
}

function effectiveNumber(value) {
  const number = Number(value ?? 0);

  return Number.isFinite(number) ? number : 0;
}

function effectiveBoolean(value) {
  return value === true || value === 1 || value === "1" || value === "true";
}

function conditionSignature(item) {
  return JSON.stringify([
    effectiveNumber(item?.pivot?.minimum_order),
    effectiveNumber(item?.pivot?.delivery_charge),
    effectiveNumber(item?.pivot?.free_above),
    effectiveBoolean(item?.pivot?.disabled),
  ]);
}

export function deliveryPostcodeGroupKey(item) {
  return `${normalizedCountryId(item)}|${normalizedPostcode(item)}`;
}

export function sameDeliveryPostcodeGroup(left, right) {
  return deliveryPostcodeGroupKey(left) === deliveryPostcodeGroupKey(right);
}

export function groupDeliveryPostcodes(items = []) {
  const groups = new Map();

  items.forEach((item) => {
    const key = deliveryPostcodeGroupKey(item);

    if (!groups.has(key)) {
      groups.set(key, []);
    }

    groups.get(key).push(item);
  });

  return Array.from(groups.values()).map((group) => {
    const representative = [...group].sort((left, right) => {
      const mainCityDifference = Number(right.zcMainCity || 0) - Number(left.zcMainCity || 0);

      return mainCityDifference || Number(left.id || 0) - Number(right.id || 0);
    })[0];
    const cities = Array.from(new Set(group.map((item) => item.zcCity).filter(Boolean)))
      .sort((left, right) => left.localeCompare(right));

    return {
      ...representative,
      zcCity: cities.join(", "),
      zcCities: cities,
      postcode_group_size: group.length,
      conditions_inconsistent: Boolean(representative.conditions_inconsistent) ||
        new Set(group.map(conditionSignature)).size > 1,
    };
  });
}

export function availableDeliveryPostcodeGroups(items = [], linkedItems = []) {
  return groupDeliveryPostcodes(items)
    .filter((option) => !linkedItems.some((linked) => (
      sameDeliveryPostcodeGroup(linked, option)
    )));
}
